import { useState } from "react"
import { Link } from "react-router-dom"

function Headers() {
    const [open, setOpen] = useState(false)
  return (
    <header className="header__area header__v2">
        <div className="container maxw_1640">
            <div className="row align-items-center">
                <div className="col-xl-2 col-lg-3 col-md-6 col-7 left__border">
                    <div className="logo">
                        <Link to="/"><img src="assets/img/logo/logo.png" alt="ttn-logo" /></Link>
                    </div>
                </div>
                <div className="col-xl-10 col-lg-9 col-md-6 col-5">
                    <div className="menu__area">
                        <div className="main-menu d__nav">
                            <nav>
                                <ul>
                                    <li className="active"><a href="/">Home</a></li>
                                    <li><a href="#about">About Us</a></li>
                                    <li><a href="#services">Services</a></li>
                                    <li><a href="#process">Process</a></li>
                                    <li><a href="#testimonial">Testimonial</a></li>
                                    <li><a href="#clients">Clients</a></li>
                                    <li><a href="https://ttnconsulting.zohorecruit.com/jobs/Careers" target="_blank">Careers</a></li>
                                </ul>
                            </nav>
                        </div>
                        {/* <div className="side-menu-icon info-open d-lg-none">
                            <button className="side-toggle overlay-open"><i className="far fa-bars"></i></button>
                        </div>
                        <div className="side-mobile-menu">
                            <button className="side-info-close"><i className="fal fa-times"></i></button>
                            <div className="mobile-menu">
                                <nav>
                                    <ul>
                                        <li className="active"><a href="/">Home</a></li>
                                        <li><a href="#about">About Us</a></li>
                                        <li><a href="#services">Services</a></li>
                                        <li><a href="#process">Process</a></li>
                                        <li><a href="#testimonial">Testimonial</a></li>
                                        <li><a href="#clients">Clients</a></li>
                                    </ul>
                                </nav>
                            </div>
                        </div> */}
                        
                        <div className="offcanvas-overlay"></div>
                        <div className="menu__area--right ul_li">
                            <div className="button ml-60">
                                <a className="thm_btn" href="#contact">Contact Us</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
  )
}

export default Headers
